import { useEffect, useRef } from "react";
import AppDrawer from "../../../../components/drawer";
import FlexBox from "../../../../components/layouts/Flexbox";
import { Box, Typography } from "@mui/material";
import { Error } from "@mui/icons-material";
import ZoomPlayer from "../../../../components/ZoomPlayer";

export default function ZoomMeetingModal({
  open,
  videoUrl,
  vttUrl,
  downloadUrls,
  summaryData,
  userData,
  onClose,
}) {
  const iframeRef = useRef(null);

  const handleClose = () => {
    if (iframeRef.current) {
      iframeRef.current.src = "";
    }
    onClose();
  };

  useEffect(() => {
    return () => {
      if (iframeRef.current) {
        iframeRef.current.src = "";
      }
    };
  }, []);

  return (
    <AppDrawer
      open={open}
      onClose={handleClose}
      title="Play recording"
      PaperProps={{ sx: { width: { xs: "100%", md: "80%", xl: "70%" }, maxWidth: "100%" } }}
    >
      {!videoUrl ? (
        <FlexBox
          pb={2}
          justifyContent="center"
          alignItems="center"
          gap={0.5}
          sx={{ minHeight: 400 }}
        >
          <Error fontSize="medium" color="error" />
          <Typography component="span" color="error" pt={0.5}>
            Failed to load the recording. Please try again later.
          </Typography>
        </FlexBox>
      ) : videoUrl.includes("zoom.us") ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: 2,
          }}
        >
          <iframe
            ref={iframeRef}
            src={videoUrl}
            title="Zoom Recording"
            style={{ width: "100%", height: "100%", border: 0 }}
            allow="autoplay; fullscreen; picture-in-picture"
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            border: "none",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <ZoomPlayer
            title={getTitle(userData)}
            videoUrl={videoUrl}
            vttUrl={vttUrl}
            downloadUrls={downloadUrls}
            summaryData={summaryData}
          />
        </Box>
      )}
    </AppDrawer>
  );
}

function getTitle(userData) {
  return `Virtual Meeting (Facilitated by Execweb) - ${userData?.ambassador?.firstName}, ${userData?.ambassador?.title}  @ ${userData?.ambassador?.company}`;
}
